import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Review photos load

export const STROLLER_REVIEW_PHOTO_FETCH_TRIGGER = "STROLLER_REVIEW_PHOTO_FETCH_TRIGGER";
export interface StrollerReviewPhotoFetchTriggerAction {
    readonly type: typeof STROLLER_REVIEW_PHOTO_FETCH_TRIGGER;
    readonly strollerSlug: string;
    readonly reviewId: number;
    readonly photoId: number;
}
export const STROLLER_REVIEW_PHOTO_FETCH_REQUEST = "STROLLER_REVIEW_PHOTO_FETCH_REQUEST";
export interface StrollerReviewPhotoFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLER_REVIEW_PHOTO_FETCH_REQUEST;
    readonly strollerSlug: string;
    readonly reviewId: number;
    readonly photoId: number;
}
export interface StrollerReviewPhotoFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        stroller: number;
        strollerReviews: number[];
    };
}
export const STROLLER_REVIEW_PHOTO_FETCH_SUCCESS = "STROLLER_REVIEW_PHOTO_FETCH_SUCCESS";
export interface StrollerReviewPhotoFetchSuccessAction extends APISuccessAction<StrollerReviewPhotoFetchNormalizedResponse> {
    readonly type: typeof STROLLER_REVIEW_PHOTO_FETCH_SUCCESS;
    readonly strollerSlug: string;
    readonly reviewId: number;
    readonly photoId: number;
}
export const STROLLER_REVIEW_PHOTO_FETCH_FAILURE = "STROLLER_REVIEW_PHOTO_FETCH_FAILURE";
export interface StrollerReviewPhotoFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLER_REVIEW_PHOTO_FETCH_FAILURE;
    readonly strollerSlug: string;
    readonly reviewId: number;
    readonly photoId: number;
}

export const strollerReviewPhotoFetchTrigger = (
    strollerSlug: string,
    reviewId: number,
    photoId: number,
): StrollerReviewPhotoFetchTriggerAction => ({
    type: STROLLER_REVIEW_PHOTO_FETCH_TRIGGER,
    strollerSlug,
    reviewId,
    photoId,
});
export const strollerReviewPhotoFetchApi = {
    request: (
        strollerSlug: string,
        reviewId: number,
        photoId: number,
    ): StrollerReviewPhotoFetchRequestAction => ({
        type: STROLLER_REVIEW_PHOTO_FETCH_REQUEST,
        strollerSlug,
        reviewId,
        photoId,
    }),
    success: (
        strollerSlug: string,
        reviewId: number,
        photoId: number,
        response: StrollerReviewPhotoFetchNormalizedResponse,
    ): StrollerReviewPhotoFetchSuccessAction => ({
        type: STROLLER_REVIEW_PHOTO_FETCH_SUCCESS,
        strollerSlug,
        reviewId,
        photoId,
        response,
    }),
    failure: (
        strollerSlug: string,
        reviewId: number,
        photoId: number,
        error: string,
    ): StrollerReviewPhotoFetchFailureAction => ({
        type: STROLLER_REVIEW_PHOTO_FETCH_FAILURE,
        strollerSlug,
        reviewId,
        photoId,
        error,
    }),
};
